import { createAction } from '@reduxjs/toolkit';

export const setPageViewEventFired = createAction('pageView/SET_PAGE_VIEW_EVENT_FIRED');
export const clearPageViewEventFired = createAction('pageView/CLEAR_PAGE_VIEW_EVENT_FIRED');
